import Attractions from "@/components/sections/Attractions";
import Services from "@/components/sections/Services";

export default function ActivitiesPage() {
  return (
    <div className="pt-16 min-h-screen bg-white">
      <Attractions />
      <Services />
    </div>
  );
}
